import { useState } from "react";
import './ApiBlockArea.css'
import ReactTextareaAutosize from "react-textarea-autosize";
import JsonFormatter, {formatJsonValue} from '../../JsonFormatter/JsonFormatter';


function ApiBlockArea({value, setValue, onBlur}) {

    const [body, setBody] = useState(value)
    const [formatStatus, setFormatStatus] = useState(null)
    
    // DisableSpellCheck need to be some when the composent is mounted, no use effect yes !
    const disableSpellCheck = (ref) => {
        if(!ref) {
            return;
        }
        ref.spellcheck = false
    }

   
    const formatCurrentJson = () => {
        const result = formatJsonValue(body);

        if (result.success === true) {
            setBody(result.value);
            setValue(result.value);
            setFormatStatus('success');
        } else if (result.success === false) {
            setFormatStatus('error');
        }

        setTimeout(() => {
            setFormatStatus(null);
        }, 1500);
    }

    const onTextareaKeyDown = (e) => {
        // Alt+Shift+F 
        if (e.altKey && e.shiftKey && !e.ctrlKey && !e.metaKey && e.code === 'KeyF') {
            e.preventDefault();
            formatCurrentJson();
        }
    }

    const onChange = (e) => {
        setBody(e.target.value)
        setValue(e.target.value)
    }
    return (
        <div className="api-block-area" style={{ width : 'calc(100% - 10px)'}}>
            <div className="api-block-toolbar">
                <JsonFormatter onClick={formatCurrentJson} status={formatStatus} />
            </div>
            <ReactTextareaAutosize ref={(ref) => disableSpellCheck(ref)} style={{ marginTop : 20, marginLeft : 10}} value={body} onChange={onChange} onBlur={onBlur} onKeyDown={onTextareaKeyDown} className="input editor-input title_input" placeholder='{}' minRows={3}/>
        </div>
    )
}

export default ApiBlockArea